module.exports = __webpack_public_path__ + "img/vraag-antwoord.9019ef22.png";